import React, { Fragment, useEffect } from "react";
import Header from "../../common/Header";
import Sidebar from "./Sidebar";
import { getAdminUserId } from "../../common/CommonFunctions";
import { useDispatch } from "react-redux";
import {
  AgencygetLoggedUserDetails,
} from "../../../redux/actions";

export default function AdminLayout() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(AgencygetLoggedUserDetails(getAdminUserId()));
  }, []);
  return (
    <Fragment>
      <Header />
      <Sidebar />
     
    </Fragment>
  );
}
